<template>
  <TaskTypeForm :taskTypeId="taskTypeId" @done="onDone"></TaskTypeForm>
</template>

<script>
import TaskTypeForm from 'CORE/components/task/type/form'
import isString from 'lodash/isString'
import get from 'lodash/get'

export default {
    name: 'TaskTypeEditView',
    components: {
        TaskTypeForm,
    },
    computed: {
        taskTypeId() {
            const id = get(this.$route.params, 'id')
            console.assert(isString(id), `ID must be a string`) // TODO check if id is valid uuid or not
            return id
        },
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'taskTypesList' })
        },
    },
}
</script>
